import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './RatingSubmitButton.module.scss';

type RatingSubmitButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
};

export const RatingSubmitButton: FC<RatingSubmitButtonProps> = ({
  disabled,
  loading,
  onClick
}) => (
  <button
    type="button"
    className={classNames(classes.button, disabled && classes.disabled)}
    disabled={disabled || loading}
    onClick={onClick}
  >
    {loading ? 'Отправка…' : 'Проголосовать'}
  </button>
);
